<template>
    <div class="wrapper-body">
      <v-card class="flex-container mb-3" style="border-radius: 12px;">
       
  <v-toolbar class="shadow-none" style="flex: unset" content-class="h-auto">
      <div class="row" style="display: flex; justify-content: space-between" >
          <div class="col-4" style="display: flex">
              <div class="custom-icon-wrapper" style="display: inline-block"> <v-icon @click="backToAdminPage">custom-icon left-arrow-icon</v-icon> </div>
              <v-toolbar-title style="padding-top: 10px; display: inline" class="size-16 dark-text mx-5" >{{ $t("res_Label_ManageExternalEntities") }}</v-toolbar-title >
          </div> 
       
           <div class="col-1" style="display: flex; justify-content: flex-end">
            <v-btn  style="margin-right: 20px" color="primary" @click="AddExtenalStructure()">{{ $t("res_ButtonText_AddStructure") }}</v-btn>
              <v-btn color="primary" @click="OpenMergeForm()">{{ $t("res_ButtonText_Merge") }}</v-btn>
          </div>
      </div>
  </v-toolbar>
  
        
        <div class="border-top organization-management-dialog d-flex h-100">
          <div
              style="height: calc(85vh); max-height: calc(85vh)"
              class="tree-section col-md-4 col-lg-4 d-flex flex-column bg-white">
              <!--<div class="tree-wrapper h-100 overflow-auto d-flex flex-column bg-white">-->
              <div class="d-flex gap-2">
                  <div class="flex-1">
                  <div class="search-bar-gray">
                      <v-btn @click="handleSearch()"><v-icon>mdi-magnify</v-icon></v-btn>
                      <v-text-field
                      v-model="searchVal"
                      solo
                      :label="$t('res_Label_SearchPlaceHolder')"
                      @keydown.enter="handleSearch()"
                      ></v-text-field>
                      <v-btn @click="clear()"><v-icon>mdi-close</v-icon></v-btn>
                  </div>
                  </div>
              </div>
              <v-treeview
                  class="flex-1 overflow-auto"
                  dense
                  :active:sync="active"
                  :items="items"
                  ref="tree"
                  :load-children="fetchStructure"
                  :open="openNodes"
                  activatable
                  item-key="id"
                  color="success"
                  open-on-click
                  transition
              >
                  <template v-slot:label="{ item }">
                  <div @contextmenu="show($event, item)" @click="openEdit(item)">
                      {{ (language =='ar' && item.nameAr != '')?item.nameAr :item.name }}
                  </div>
                  </template>
                  <template v-slot:prepend="{ item, open }">
                  <div @contextmenu="show($event, item)">
                      <v-icon v-if="item.children">
                      {{ open ? 'mdi-chevron-down-circle' : 'mdi-chevron-right-circle' }}
                      </v-icon>
                      <v-icon v-else>mdi-account</v-icon>
                      {{ item.text }}
                  </div>
                  </template>
              </v-treeview>
  
            <!--</div>-->
          </div> 
          <div class="form-section col-md-8 col-lg-8 p-0 overflow-auto" style="height: calc(85vh); max-height: calc(85vh)"
            v-if="add_edit_Structure">
  
            <!-- Add Edit -->
            <!--<v-container fluid class="m-0 p-0 h-100">-->
            <v-card class="h-100" v-if="add_edit_Structure" ref="AddEditStructure">
              <v-toolbar class="shadow-none" content-class="h-auto">
                <div class="d-flex align-items-center">
                  <v-toolbar-title class="size-16 dark-text">
                    {{ this.currentStructureName }} {{ this.currentStructureMode }}
                  </v-toolbar-title>
                </div>
                <v-spacer></v-spacer>
              </v-toolbar>
  
              <div class="border-top p-4 flex-1 overflow-auto">
                <v-layout wrap>
                  <div class="flex-1">
                    <label>{{ $t("res_Label_Code")}}</label>
                    <v-text-field :disabled="!isEditable"
                      v-model="structureForm.code"
                      label=""
                      solo
                    ></v-text-field>
                  </div>
                  <div class="flex-1">
                    <label class="">{{ $t("res_Label_Name")}}<span> *</span></label>
                    <v-text-field :disabled="!isEditable"
                      v-model="structureForm.name"
                      :rules="rules"
                      label=""
                      solo
                    ></v-text-field>
                  </div>
                </v-layout>
              
              <v-layout wrap>
                  <div class="flex-1">
                      <label>{{ $t("res_Label_NameAr")}}</label>
                      <v-text-field v-model="structureForm.nameAr" label="" :disabled="!isEditable" solo></v-text-field>
                  </div>
                  <div class="flex-1">
                    <label class="">{{ $t("res_Label_SelectCompany") }} </label>
                    <multi-select class="light-bg add-arrow" style="height=100px; " v-model="structureForm.company" label="name" track-by="id"
                        open-direction="bottom" :options="companyitems" :searchable="false" 
                        :internal-search="false" :disabled="structureForm.disableCompany" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                        :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false"
                        :placeholder="$t('res_Label_Select')" >
                    </multi-select>
                </div>
              </v-layout>
              <v-layout wrap>
                <div class="flex-1">
                    <label>{{ $t('res_Label_DisableTransfer') }}</label>
                    <v-checkbox v-model="structureForm.disableTransfers" :disabled="!isEditable" label="" solo></v-checkbox>
                  </div>
                  <div class="flex-1">
                    <label>{{ $t('res_Label_IsExternal') }}</label>
                    <v-checkbox v-model="structureForm.external" disabled label="" solo></v-checkbox>
                  </div>
                  <div class="flex-1">
                    <label>{{ $t('res_Label_IsActive') }}</label>
                    <v-checkbox v-model="structureForm.active" :disabled="!isEditable" label="" solo></v-checkbox>
                  </div>
              </v-layout>
  
              <v-layout wrap>
                  <div class="flex-1" v-if="structureForm.isCompany && constants.isFullAdmin && enableEntityConfiguration">
                      <label>{{ $t('res_Label_StorageDatabaseName') }}</label>
                      <v-text-field v-model="structureForm.storageDatabaseName" label="" :disabled="!isEditable" solo></v-text-field>
                  </div>
                  <div class="flex-1" v-if="structureForm.isCompany && constants.isFullAdmin && enableEntityConfiguration">
                      <label>{{ $t('res_Label_StorageFile') }}</label>
                      <v-text-field v-model="structureForm.storageFile" label="" :disabled="!isEditable" solo></v-text-field>
                  </div>
              </v-layout>
  
              <v-layout wrap style="display: none">
                  <div class="flex-1">
                    <label class="ml-3">{{ $t("res_Label_Manager")}}</label>
                    <Multiselect
                      style="width: 400px"
                      v-model="structureForm.manager"
                      label="name"
                      track-by="id"
                      open-direction="bottom"
                      placeholder="Select manager"
                      :options="exceptionUsers"
                      :searchable="true"
                      :loading="loading"
                      :internal-search="false"
                      dense
                      :clear-on-select="true"
                      :close-on-select="true"
                      :options-limit="300"
                      :max-height="600"
                      :show-no-results="false"
                      :hide-selected="false"
                      :multiple="false"
                      outlined
                      @search-change="asyncFindExceptionUser"
                      @close="exceptionUsers = []"
                      :disabled="isEditable? '':'disabled'"
                    >
                      <template slot="option" slot-scope="props">
                        <div style="height: 50px; width: 100%; display: flex">
                          <div class="" style="">
                            <v-avatar
                              color="#eff2f5"
                              size="43"
                              >{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar
                            >
                          </div>
                          <div class="ad__box" v-if="props.option.isUser">
                            <p class="ad__text__bold">{{ props.option.name }}</p>
                            <p class="ad__text">
                              {{ GetMultiSelectSubHeaderDisplay(props.option) }}
                            </p>
                          </div>
                          <div class="ad__box" v-else>
                            <p class="ad__text__bold">{{ props.option.name }}</p>
                            <p class="ad__text">
                              {{ GetMultiSelectSubHeaderDisplay(props.option) }}
                            </p>
                          </div>
                        </div>
                      </template>
                      <template slot="noOptions" slot-scope="props">
                        {{$t("res_Msgs_EmptySearch")}}
                      </template>
                    </Multiselect>
                  </div>
                </v-layout>
  
                <div class="actions d-flex">
                  <v-btn @click="submitData" color="primary" dense>
                    {{ $t("res_ButtonText_Submit")}}
                  </v-btn>
                </div>
              </div>
            </v-card>
          </div>
  
          
          <div class="form-section col-md-8 col-lg-8 p-0 overflow-auto" style="height: calc(85vh); max-height: calc(85vh)" v-show="show_merge_Structure_Form">
                          <v-card class="h-100">
                              <div class="border-top p-4 flex-1 overflow-auto">
                                  <div class="row mb-1">
                                      <div class="col-12">
                                          {{ $t("res_Label_Source_ToBeRemoved") }}
                                      </div>
                                  </div>
                                  <div class="row mb-3 mt-0">
                                      <div class="col-2" style="display: block; margin: auto">
                                          {{ $t("res_Label_Source") }}*
                                      </div>
                                      <div class="col-4">
                                          <StructureUserSelector
                                              :showInternalUsers="false"
                                              :showExternalUsers="false"
                                              :showInternalStructures="false"
                                              :showExternalStructures="true"
                                              :excludeSelf="true"
                                              :isMultiple="false"
                                              :selectedStructureUser="toStructure_S"
                                              @structureUserSelectChanged="structureUserSelectChanged_S">
                                          </StructureUserSelector>
                                      </div>
                                      <div class="col-2" style="display: block; margin: auto">
                                          {{ $t("res_Label_Destination") }}*
                                      </div>
                                      <div class="col-4">
                                          <StructureUserSelector
                                              :showInternalUsers="false"
                                              :showInternalStructures="false"
                                              :showExternalStructures="true"
                                              :excludeSelf="true"
                                              :isMultiple="false"
                                              :selectedStructureUser="toStructure_D"
                                              @structureUserSelectChanged="structureUserSelectChanged_D">
                                          </StructureUserSelector>
                                      </div>
                                  </div> 
                                  <div class="actions d-flex">
                                      <v-btn @click="ConfirmMergeExternalStructures" color="primary" dense >
                                          {{ $t("res_ButtonText_Submit") }}
                                      </v-btn>
                                  </div>
                              </div>
                          </v-card>
          </div> 
  
          <v-menu
            v-model="showMenu"
            :position-x="x"
            :position-y="y"
            class="menu"
            :offset-y="offset"
            :close-on-content-click="false"
          >
            <v-list>
              <v-list-item
                v-for="(item, i) in menuItems"
                :key="i"
                @click="openOptionPane(item.id)"
              >
                <v-icon color="navy" v-text="item.icon"></v-icon
                >&nbsp;{{ item.title }}
              </v-list-item>
            </v-list>
          </v-menu>
        
        <div class="form-section col-md-8 col-lg-8 p-0 overflow-auto" style="height: calc(85vh); max-height: calc(85vh)"
            v-if="AddExternalUser">
  
            <v-card class="h-100" v-if="AddExternalUser" ref="AddExternalUser" style="padding-top: 30px;">
              <div>
                      <v-row>
                          <v-col cols="12" sm="4">
                              <label class="label_required">First Name<span> *</span></label>
                              <v-text-field v-model="user.firstName" placeholder="Enter First Name" class="light-bg ps-1" type="text"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="4">
                              <label class="label_required">Last Name<span> *</span></label>
                              <v-text-field v-model="user.lastName" placeholder="Enter Last Name" class="light-bg ps-1" type="text"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="4">
                              <label class="label_required">First Name (Arabic)<span> *</span></label>
                              <v-text-field v-model="user.firstNameAr" placeholder="Enter First Name (Arabic)" class="light-bg ps-1" type="text"></v-text-field>
                          </v-col>
                      </v-row>
                      <v-row>
                          <v-col cols="12" sm="4">
                              <label class="label_required">Last Name (Arabic)<span> *</span></label>
                              <v-text-field v-model="user.lastNameAr" placeholder="Enter Last Name (Arabic)" class="light-bg ps-1" type="text"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="4">
                              <label class="label_required">Email Address<span> </span></label>
                              <v-text-field v-model="user.email" placeholder="Enter Email Address" class="light-bg ps-1" type="text"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="4">
                              <label class="label_required">Profession<span> *</span></label>
                              <v-text-field v-model="user.profession" placeholder="Enter Profession" class="light-bg ps-1" type="text"></v-text-field>
                          </v-col>
                      </v-row>
                      <v-row>
                          <v-col cols="12" sm="4">
                              <label class="label_required">Profession (Arabic)<span> *</span></label>
                              <v-text-field v-model="user.professionAr" placeholder="Enter Profession (Arabic)" class="light-bg ps-1" type="text"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="4">
                              <label class="label_required">Title<span> *</span></label>
                              <v-text-field v-model="user.title" placeholder="Enter Title" class="light-bg ps-1" type="text"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="4">
                              <label class="label_required">TitleAr<span> *</span></label>
                              <v-text-field v-model="user.titleAr" placeholder="Enter TitleAr" class="light-bg ps-1" type="text"></v-text-field>
                          </v-col>
                      </v-row>
                      <v-row>
                          <v-col cols="12" sm="4">
                              <label class="label_required">Salutation<span> *</span></label>
                              <v-text-field v-model="user.salutation" placeholder="Enter Salutation" class="light-bg ps-1" type="text"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="4" v-if="constants.client_version_Id == 'DDA'">
                              <label class="label_required">Can Sign<span> *</span></label>
                              <v-checkbox v-model="user.externalUserCanSign"></v-checkbox>
                          </v-col>
                      </v-row>
                      <v-row>
                      <v-col cols="12" sm="4" style="margin-left: 72%;">
                          <v-btn color="primary" @click="AddExternalUser=false" width="100">Cancel</v-btn>
                          <v-btn @click="upsertUser" color="primary" style="margin-left:25px;" width="100">Continue</v-btn>
                      </v-col>
                      </v-row>
                  </div>
          </v-card>
          </div>
          <div v-if="showListUsers" class="form-section col-md-8 col-lg-8 p-0 overflow-auto" style="height: calc(85vh); max-height: calc(85vh)"
            >
  
            <v-card class="h-100"   style="padding-top: 30px;">
              <div  class="mt-4" :class="{ 'ml-10 mr-4': lang == 'en' || lang == null, 'mr-10 ml-4': lang == 'ar' }">
                  <div class="d-flex mt-3 bg-gray text-white rounded-3" style="background-color: #7DA1C4">
                      <span style="width:40px"></span>
                      <span class="col-xl">{{ utils.SwitchByLang($t("res_Label_FirstName"),$t("res_Label_FirstNameAr")) }}</span>
                      <span class="col-xl">{{ utils.SwitchByLang($t("res_Label_MiddleName"),$t("res_Label_MiddleNameAr")) }}</span>
                      <span class="col-xl">{{ utils.SwitchByLang($t("res_Label_LastName"),$t("res_Label_LastNameAr")) }}</span>
                      <span class="col-xl">{{ $t("res_Label_Email") }}</span>
                      <span class="col-xl">{{ utils.SwitchByLang($t("res_Label_Title"),$t("res_Label_TitleAr")) }}</span>
                      <span class="col-xl">{{ utils.SwitchByLang($t("res_Label_Profession"),$t("res_Label_ProfessionAr")) }}</span>
                      
                  </div>
                  <div v-if="sendingDesignatedPersonsList.length==0" class="justify-content-center d-flex m-2 mt-6 rounded-3 ml-14">
                      <span class="align-items-center weight-500">{{ $t("res_Label_NoData") }}</span>
                  </div>
                  <!--Data Of children-->
                  <div class="d-flex rounded-3"  v-else
                       v-for="(person,index) in sendingDesignatedPersonsList">
                      <span class="d-flex justify-content-center align-items-center" style="width: 40px; height: 40px;">
                          <v-checkbox @click="handleDesignatedPersonCheckboxClick(person)" v-model="person.isSelected" class="bg-white"></v-checkbox>
                      </span>
                      <span class="col-xl text-cut">{{ utils.SwitchByLang(person.firstName,person.firstNameAr) }}</span>
                      <span class="col-xl text-cut">{{ utils.SwitchByLang(person.middleName,person.middleNameAr) }}</span>
                      <span class="col-xl text-cut">{{ utils.SwitchByLang(person.lastName,person.lastNameAr) }}</span>
                      <span class="col-xl text-cut">{{ person.email}}</span>
                      <span class="col-xl text-cut">{{ utils.SwitchByLang(person.title,person.titleAr) }}</span>
                      <span class="col-xl text-cut">{{ utils.SwitchByLang(person.profession,person.professionAr) }}</span>

                        <div class="custom-icon-wrapper">
                              <v-icon  @click="openDeleteDialog(person)">custom-icon white-bg delete-icon</v-icon>
                           </div>
                      <div  class="p-2 d-flex justify-center" style="width:75px">
                          <button class=""
                                  @click="showAddEditDialog(person)">
                              <v-icon class="light">mdi-pencil</v-icon>
                          </button>
                       
                      </div>
                         
                  </div>
              </div>
              </v-card>
          </div>
  
      </div>
      </v-card>
    </div>
  </template>
      
  <script>
      import axios from 'axios'
      import router from '@/router/index.js'
      import constants from '@/assets/js/constants'
      import Multiselect from 'vue-multiselect'
      import SendSignRule from '@/components/SendSignRule.vue'
      import AutoForward from '@/components/AutoForward.vue'
      import TemplateDelegate from '@/components/TemplateDelegate.vue'
      import ManageTemplate from '@/components/ManageTemplate.vue'
      import * as utils from '@/assets/js/common.js'
      import StructureUserSelector from "@/components/StructureUserSelector.vue"; 
      import MultiSelect from 'vue-multiselect';
  
  export default {
      name: 'OrgManagement',
      components: { SendSignRule, AutoForward, TemplateDelegate, MultiSelect, ManageTemplate , StructureUserSelector},
      data() {
          return {
              showListUsers: false,
              toStructure_SId: 0,
              toStructure_S: {},
              toStructure_DId: 0,
              toStructure_D: {},
              showUpdateStructureUserBtn: false,
              sendingDesignatedPersonsList:[],
              language:'en',
              show1: false,
              offset: true,
              password: 'Password',
              active: [],
              currentUserId: 1,
              utils: utils,
              selectedStructureId: 1,
              selectedParentId: 0,
              currentStructureName: '',
              currentStructureMode: '',
              userId: '',
              exceptionUsers: [],
              managers: [],
              selectedUsers: [],
              selectedStructureUserIds: [],
              uploadedFile: [],
              structureForm: {
                  code: '',
                  name: '',
                  manager: [],
                  nameFr: '',
                  nameAr: '',
                  external: true,
                  active: true,
                  disableTransfers : false ,
                  document_date_menu: false,
                  date: '',
                  isCompany:false,
                  storageDatabaseName:'',
                  storageFile:'',
                  company: null,
                  disableCompany: false
              },
            
              structureData: {
                  structureDataArray: []
              },
  
              image: null,
              showMenu: false,
              isEdit: false,
              loading: false,
              showUsers: false,
              showManageTemplates: false,
              searchVal: '',
  
              rules: [
                  value => !!value || 'This value is required.',
                  value => (value && value.length >= 1),
              ],
  
              structureHeaders: [
                  { text: 'Id', value: 'id', sortable: false, align: ' d-none'},
                  { text: 'Structure Name', value: 'structure', sortable: false },
                  { text: 'Privacy Level', value: 'privacyLevel', sortable: false },
                  { text: 'Contact Role', value: 'contactRole', sortable: false },
                  { text: 'Profession', value: 'profession', sortable: false },
                  { text: 'Profession Ar', value: 'ProfessionAr', sortable: false },
                  { text: 'Structure Receiver', value: 'isStructureReceiver', sortable: false },
                  { text: 'Designated Person', value: 'isDesignatedPerson', sortable: false },
              ],
              systemRoles: [
                  { text: 'Administrator', value: 1 },
                  { text: 'User', value: 2 }
              ],
              genders: [
                  { text: 'Male', value: 'M' },
                  { text: 'Female', value: 'F' }
              ],
              privacy_items: [],
              contactRoles: [],
           
              items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
              x: 0,
              y: 0,
              menuItemsForParent:[
                  {
                      id: 4,
                      title: this.$t("res_MenuItem_Add_structure"),
                      icon: 'mdi-plus-box'
                  },  
                   {
                      id: 5,
                      title: this.$t("res_MenuItem_Edit"),
                      icon: 'mdi-pencil-box-outline'
                  },
                  {
                      id: 11,
                      title: this.$t("res_MenuItem_Add_User"),
                      icon: 'mdi-account',
                  },
                  {
                      id: 12,
                      title: this.$t("res_MenuItem_show_User"),
                      icon: 'mdi-eye-outline',
                  },
              ],
              menuItemsForChiled: [
                  {
                      id: 4,
                      title: this.$t("res_MenuItem_Add"),
                      icon: 'mdi-plus-box'
                  },
                  {
                      id: 5,
                      title: this.$t("res_MenuItem_Edit"),
                      icon: 'mdi-pencil-box-outline'
                  },
                  {
                      id: 6,
                      title: this.$t("res_MenuItem_Delete"),
                      icon: 'mdi-minus-circle'
                  },
                  {
                      id: 8,    
                      title: this.$t("res_MenuItem_ActiveStructure"),
                      icon:   'mdi-play-circle' , 
                  },
                  {
                      id: 11,
                      title: this.$t("res_MenuItem_Add_User"),
                      icon: 'mdi-account',
                  },
                  {
                      id: 12,
                      title: this.$t("res_MenuItem_show_User"),
                      icon: 'mdi-eye-outline',
                  },
              ],
              user: {
                  structureId: 0,
                  isDefaultDesignatedPerson:true,
                  externalUserCanSign: false
              },
              AddExternalUser:false,
              menuItems: [],
              items: [],
              openNodes: [],
              clickedUser: true,
              clickedWindow: false,
              showList: false,
              delegateKey: 0,
              show_merge_Structure_Form: false,
              add_edit_Structure: false,
              editStructureDialog: false,
              addUser: false,
              userMetadata: false,
              disableFields: false,
              disableMailField: false,
              showStructures: false,
              showApplications: false,
              isSubmit: true,
              sendStructureIdProp: 0,
              autoForwardKey: 0,
              templateDelagationKey: 0,
              sendSignRuleKey: 0,
              templatKey: 0,
              constants: constants,
              enableEntityConfiguration: admin_enableEntityConfiguration,
              enableAddTopParnetStructure : true,
              isEditable: false,
              companyItems: [],
              companyId: null
          };
      },
      watch: {
          uploadedFile(newSource, oldSource) {
              if (newSource != oldSource) {
                  var binaryData = [];
                  binaryData.push(newSource);
                  this.image = URL.createObjectURL(new Blob(binaryData, { type: "image/png" }))
              }
          }
      },
      mounted() 
      {
          this.asyncFindExceptionUser("")
          this.asyncStructuresTreeView()
          this.getConstantData()
          this.getDesignatedPerson()
          this.getCompaniesForUser()
          this.language = localStorage.getItem('lang');
          eval(admin_enableEntityConfiguration)
          
          if(!admin_enableAddTopParentForNonAdmin && !constants.isFullAdmin){
              this.enableAddTopParnetStructure = false;
          }
          //eval(admin_enableAddTopParentForNonAdmin)
      },
      methods:
      {
        getCompaniesForUser() {
                window.showLoading()
                axios.get(constants.baseApiUrl + "Admin/GetCompaniesForUser")
                    .then((res) => this.companyitems = res.data.filter(company => company.external === false))
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading());
            }, 
          showAddEditDialog(stucture, structureId) 
          {
              this.user = { ...stucture };
              this.showListUsers = false;
              this.AddExternalUser =true;
          },
          getDesignatedPerson(){
              this.sendingDesignatedPersonsList = []
              axios.get(constants.baseApiUrl + 'Document/GetDesignatedPersons?structureIds=' + this.selectedStructureId
                                                  + '&search=&personsIds=&selectExternal=1&getAll=true' )
                      .then((res) => 
                      {
                          if ((res.data == null || res.data.length == 0))
                              return;
                              this.sendingDesignatedPersonsList = res.data;
                      })
                      .catch(error => console.log(error))
          },
          loadChildData(e){
              alert('Expanded')
          },
          async readFile(file, successHandler) 
          {
              var reader = new FileReader();
                  var fileByteArray = [];
                  reader.readAsArrayBuffer(file);
                  reader.onloadend = function (evt) {
                      if (evt.target.readyState == FileReader.DONE) 
                      {
                          var arrayBuffer = evt.target.result,
                              array = new Uint8Array(arrayBuffer);
                          for (var i = 0; i < array.length; i++) 
                          {
                              fileByteArray.push(array[i]);
                          }
                          
                          successHandler(fileByteArray);
                      }
                  }
          },
          getConstantData()
          {
              this.privacy_items = constants.privacies;
              this.contactRoles = constants.contactRoles;
          },
          backToAdminPage(){
              router.push({ name: 'admin' })
          },
          showEditStructureUserData(item)
          {
              this.showUpdateStructureUserBtn = true;
              this.structureData.structure = {name: item.structure, id: item.id};
              this.structureData.structureDisable = true;
              this.structureData.contactRole = this.contactRoles.find(x => x.name == item.contactRole);
              this.structureData.privacyLevel =  this.privacy_items.find(x => x.name == item.privacyLevel);
              this.structureData.profession = item.profession;
              this.structureData.professionAr = item.ProfessionAr;
              this.structureData.isStructureReceiver = item.isStructureReceiver;
              this.structureData.isDesignatedPerson = item.isDesignatedPerson;
          },
          handleSearch: function () 
          {
              if (this.searchVal != "") 
              {
                  window.showLoading()
                  var params = "?search=" + this.searchVal;
                  axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForManageExternals' + params, { headers: constants.headers })
                      .then(res => 
                      {
                          if (res.data != null)
                          {
                              this.openNodes = []
                              this.items = res.data;
                               this.items.forEach(ele => {
                                  this.insertion(ele);
                              });
  
                            //   if (this.items.length > 0) {
                            //       this.$refs.tree.updateAll(true);
                            //   }
                          }
                      })
                      .catch(err => console.warn(err))
                      .finally(() => window.hideLoading());
              }
              else 
              {
                  this.asyncStructuresTreeView();
              }
          },
          clear() 
          {
              this.searchVal = '';
              this.items = [];
              this.openNodes = [];
              this.asyncStructuresTreeView();
          },
          insertion: function (ele) {
              ele.isUser = ele.userId != null
              ele.isChild = true
              ele.position = ele.position
  
              this.openNodes.push(ele.id)
              if (ele.children.length > 0) {
                  ele.children.forEach(item => {
                      this.insertion(item)
                  });
              }
          },
          async asyncStructuresTreeView() 
          {
              this.items = [];
              axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForManageExternals')
                  .then((res) => 
                  {
                      if (res.data != null)
                      {
                          res.data.forEach(element => {
                              var isParent = false;
                              if(element.parentId == null) {isParent = true;}
                              var item = {
                                  id: element.id,
                                  name: element.name,
                                  nameAr:element.nameAr,
                                  children: [],
                                  isParent: isParent
                              };
                              this.items.push(item);
                          });
                      }
                  }).catch(err => console.warn(err))
          },
          DelegationTemplateRender: function () 
          {
              this.showTemplateDelegation = true;
              this.sendStructureIdProp = this.selectedStructureId
          },
          asyncFindExceptionUser(query) {
              var methodUrl = 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&disableOtherInternalEntitiesAsExternal=true&search=';
  
              axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                  .then(res => 
                  {
                      if(res.data != null)
                      {
                          this.exceptionUsers = res.data
                      }
                  })
                  .catch(err => console.warn(err))
          },
          async fetchStructure(item) 
          {
              return axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForManageExternals?parentId=' + item.id, { headers: constants.headers })
                  .then(res => 
                  {
                      if (res.data != null)
                      {
                          var jsonObjects = [];
                          res.data.forEach(element => {
                              var isParent = false;
                              if(element.parentId == null) isParent = true;
                              var childItem = {
                                  id: element.id,
                                  name: element.name,
                                  nameAr:element.nameAr,
                                  children: [],
                                  isParent: isParent
                              };
                              jsonObjects.push(childItem);
                          });
                      }
                      item.children.push(...jsonObjects);
                  })
                  .catch(err => console.warn(err))
          },
          getSelectedStructureData(id) 
          {
              return axios.get(constants.baseApiUrl + 'StructureUser/GetSelectedStructure?ids=' + id.toString(), { headers: constants.headers })
                  .then(res => 
                  {
                     if (res.data != null)
                     {
                         this.structureForm.code = res.data[0].code
                         this.structureForm.name = res.data[0].name
                         this.structureForm.nameAr = res.data[0].nameAr
                         this.structureForm.external = res.data[0].external
                         this.structureForm.isCompany=res.data[0].isCompany
                         this.structureForm.storageDatabaseName=res.data[0].storageDatabaseName
                         this.structureForm.storageFile=res.data[0].storageFile
                         this.structureForm.disableTransfers = res.data[0].disableTransfers
                         this.structureForm.active = res.data[0].active
                         this.structureForm.company = this.companyitems.find(x=>x.id == res.data[0].companyId)
                         this.structureForm.disableCompany = res.data[0].disableCompany
                          
                         this.selectedParentId = res.data[0].structureParentId
                         this.structureForm.manager = { id: res.data[0].managerId, name: res.data[0].managerName }
                     }
                  })
                  .catch(err => console.warn(err))
          },
          show(e, item) 
          {
              if(item.isParent){
                  this.menuItems = this.menuItemsForParent
              }
              else{
                  this.menuItems = this.menuItemsForChiled
              }
              e.preventDefault()
              this.selectedStructureId = item.id
              this.showMenu = false
              this.currentStructureName = item.name
              this.x = e.clientX
              this.y = e.clientY
              this.$nextTick(() => {
                  this.showMenu = true
              })
          },
          openEdit(item)
          {
              //;
              if(item.isParent){
                  this.isEditable = true;
              }else{
                  this.isEditable = true;
              }
              this.selectedStructureId = item.id;
              this.currentStructureName = item.name;
              this.openOptionPane(5);
  
          },
          resetFiles() 
          {
              this.structureForm.code = ''
              this.structureForm.name = ''
              this.structureForm.nameAr = ''
              this.structureForm.nameFr = ''
              this.structureForm.manager = []
              this.structureForm.external = true
              this.structureForm.isCompany=false
              this.structureForm.storageDatabaseName=''
              this.structureForm.storageFile=''
              this.structureForm.disableTransfers=false
          },
          submitData() 
          {
              if (this.isEdit) 
              {
                  if (this.structureForm.name) 
                  {
                      var updateStructure = {
                          id: this.selectedStructureId,
                          Code: this.structureForm.code,
                          Name: this.structureForm.name,
                          NameAr: this.structureForm.nameAr,
                          StructureParentId: this.selectedParentId,
                          ModifiedDate: Date.now,
                          External: this.structureForm.external,
                          IsCompany:this.structureForm.isCompany,
                          StorageDatabaseName:this.structureForm.storageDatabaseName,
                          StorageFile:this.structureForm.storageFile,
                          DisableTransfers:this.structureForm.disableTransfers,
                          Active:this.structureForm.active,
                          CompanyId: this.structureForm.company != null ? this.structureForm.company.id : null

                      }
                      
                      window.showLoading();
                      axios.post(constants.baseApiUrl + 'StructureUser/UpdateStructureForTreeView', updateStructure, { headers: constants.headers })
                          .then(res => 
                          {
                              if (res.data != null)
                              {
                                  window.showAlert('res_Msgs_StructureUpdated', 'success')
                                  this.clearAddEditStructureFields()
                                  this.asyncStructuresTreeView()
                              }
                          }).catch(err => console.warn(err))
                          .finally(()=>{window.hideLoading();})
                  }
                  else
                      window.showAlert('res_Msgs_FillRequired', 'warning')
              }
              else 
              {
                  if (this.structureForm.name) 
                  {
                      var addNewStructureBody = {
                          Code: this.structureForm.code,
                          Name: this.structureForm.name,
                          NameAr: this.structureForm.nameAr,
                          StructureParentId: this.selectedStructureId,
                          CreatedDate: Date.now,
                          External: this.structureForm.external,
                          IsCompany:this.structureForm.isCompany,
                          StorageDatabaseName:this.structureForm.storageDatabaseName,
                          StorageFile:this.structureForm.storageFile,
                          DisableTransfers:this.structureForm.disableTransfers,
                          Active:this.structureForm.active,
                          CompanyId : this.structureForm.company != null ? this.structureForm.company.id : null
                          
  
  
                      }
  
                      window.showLoading();
                      axios.post(constants.baseApiUrl + 'StructureUser/AddStructureForTreeView', addNewStructureBody, { headers: constants.headers })
                          .then(res => 
                          {
                              if (res.data != null)
                              {
                                  window.showAlert('res_Msgs_StructureAdded', 'success')
                                  this.clearAddEditStructureFields()
                                  this.asyncStructuresTreeView()
                              }
                          }).catch(err => console.warn(err))
                          .finally(()=>{window.hideLoading();})
                  }
                  else
                      window.showAlert('res_Msgs_FillRequired', 'warning')
              }
          },
          clearAddEditStructureFields()
          {
              this.add_edit_Structure = false
              this.structureForm.code = ''
              this.structureForm.name = ''
              this.structureForm.nameAr = ''
              this.structureForm.external = true
              this.selectedParentId = null,
              this.structureForm.isCompany=false,
              this.structureForm.storageDatabaseName='',
              this.structureForm.storageFile=''
              this.structureForm.disableTransfers=false
          },
          CapitalizeFirstLetter(str)
          {
              return utils.CapitalizeFirstLetter(str)
          },
          GetMultiSelectSubHeaderDisplay(options)
          {
              return utils.GetMultiSelectSubHeaderDisplay(options)
          },
          addParentStructure(parentId){
              this.selectedStructureId = parentId;
              this.currentStructureMode = '';
              this.openOptionPane(4)
          },
          AddExtenalStructure(){
         
                this.selectedStructureId=null;
                this.currentStructureName ='';       
                this.openOptionPane(4);
          },
          openOptionPane(id) 
          {
              if (id == 4) 
              {
                  this.isEdit = false;
                  this.footer = false;
                  this.resetFiles()
                  this.currentStructureMode = ' / (' + this.$t('res_Label_NewStructure') +')'
                  this.isEditable = true;
                  this.showListUsers = false
                  this.add_edit_Structure = true;
              }
              else if (id == 5) 
              {
                  this.showAutoForwardPane = false;
                  this.showSignSendPane = false;
                  this.showTemplateDelegation = false;
                  this.isEdit = true;
                  this.showUsername = false;
                  this.footer = false;
                  this.showManageTemplates = false;
                  this.getSelectedStructureData(this.selectedStructureId);
                  this.currentStructureMode = ' / (' + this.$t('res_Label_EditStructure') + ')'
                  this.add_edit_Structure = true;
              }
              else if (id == 6) 
              {  
                  window.showInformation(this.$t("res_Msg_DeleteConfirmation"), this.$t("res_Msgs_DeleteItemStructureDepartment"),
                      () => 
                      { 
                          window.showLoading();
                          axios.get(constants.baseApiUrl + 'StructureUser/DeleteStructureForTreeView?structureId=' + this.selectedStructureId, { headers: constants.headers })
                              .then(res => 
                              {
                                  if (res.data != null && res.data == true)
                                  {
                                      window.showAlert('res_Msgs_StructureDeleted', 'success')
                                      this.asyncStructuresTreeView()
                                  }
                                  else
                                  {
                                      window.showAlert('res_Msgs_StructureDeleteViolation', 'warning')
                                  }
                              })
                              .catch(err => console.warn(err))
                              .finally(()=>{window.hideLoading();})
                      },
                      () => 
                      { })
              }
              else if (id == 8)
              {
                window.showLoading();
                axios.get(constants.baseApiUrl + 'StructureUser/ToggleActiveStructure?structureId=' + this.selectedStructureId, { headers: constants.headers })
                    .then(res => 
                    {
                        if (res.data != null && res.data == "Success")
                        {
                            window.showAlert('res_Msgs_StructureActive', 'success')
                            this.asyncStructuresTreeView()
                        }
                        else
                        {
                            window.showAlert('res_Msgs_StructureActiveDeactiveViolation', 'warning')
                        }
                    })
                    .catch(err => console.warn(err))
                    .finally(()=>{window.hideLoading();})
              }
              else if (id == 11)
              { 
                this.add_edit_Structure = false;
                this.show_merge_Structure_Form =false;
                this.AddExternalUser= true;
                this.showListUsers = false
                this.user={}
                this.user.structureId=this.selectedStructureId;
              }
              else if (id == 12)
              { 
                this.add_edit_Structure = false;
                this.show_merge_Structure_Form =false;
                this.AddExternalUser= false;
                this.showListUsers = true
                this.user.structure={id:this.selectedStructureId};
                this.getDesignatedPerson()
              }
          }, 
          async ConfirmMergeExternalStructures() {
              if (this.toStructure_DId <= 0 ||
                  this.toStructure_SId <= 0 ||
                  this.toStructure_DId == null ||
                  this.toStructure_SId == null) {
                  window.showAlert(
                      this.$t("res_Msgs_FillRequired"),
                      "warning"
                  );
                  return;
              }
              window.showInformation(
                  this.$t("res_Label_Alert"),
                  this.$t("res_Msgs_ConfirmMergeExternalStructures"),
                  () => {
                      this.MergeExternalStructures();
                  },
                  () => {}
              );
          },
          async MergeExternalStructures() {
              try {
                  const response = await axios.put(
                      `${constants.baseApiUrl}admin/ExternalEntities?DestinationId=${this.toStructure_DId}&SourceId=${this.toStructure_SId}`
                  );
                  if (
                      response &&
                      response.data &&
                      response.data.success == true
                  ) {
                      window.showAlert(
                          this.$t("res_Label_MergeSucess"),
                          "success"
                      );
                      this.clearMergeExternalStructuresForm();
                      this.clearAddEditStructureFields();
                      this.asyncStructuresTreeView();
                  } else {
                      if (
                          response &&
                          response.data &&
                          response.data.message != ""
                      ) {
                          window.showAlert(this.$t(response.data.message));
                      } else {
                          window.showAlert(
                              this.$t("res_Label_MergeFail"),
                              "error"
                          );
                      }
                  }
              } catch (error) {
                  console.error("Error:", error);
              }
          },
          clearMergeExternalStructuresForm() { 
              this.show_merge_Structure_Form = false;
              this.toStructure_S = { id: 0, name: "" };
              this.toStructure_D = { id: 0, name: "" };
              this.toStructure_SId = 0;
              this.toStructure_DId = 0;
          },
          structureUserSelectChanged_S(selectedItem) {
              if (selectedItem) {
                  this.toStructure_S = selectedItem;
                  this.toStructure_SId = selectedItem.id;
              } else {
                  this.toStructure_S = { id: 0, name: "" };
                  this.toStructure_SId = 0;
              }
          },
          structureUserSelectChanged_D(selectedItem) {
              if (selectedItem) {
                  this.toStructure_D = selectedItem;
                  this.toStructure_DId = selectedItem.id;
              } else {
                  this.toStructure_D = { id: 0, name: "" };
                  this.toStructure_DId = 0;
              }
          },
          OpenMergeForm()
          { 
              this.show_merge_Structure_Form = true;
              this.add_edit_Structure = false;
          },
          async upsertUser() {
              if (this.user.firstName == "" || this.user.lastName == "") {
                      window.showAlert('res_Msgs_FillRequired', 'warning');
                      return;
                  }
  
                   const isValidEmail = /^((?!@)[\w!#$%&'*+\/=?^_`{|}~-]+(\.[\w!#$%&'*+\/=?^_`{|}~-]+)*)([\w!#$%&'*+\/=?^_`{|}~-]+(\.[\w!#$%&'*+\/=?^_`{|}~-]+)*)?@((?!@)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*)(\.[a-zA-Z]{2,})$/.test(this.user.email);
                   if (!isValidEmail  && this.user.email != "") {
                       window.showAlert(this.$t("res_Msgs_InvalidEmail"), 'warning')
                       return;
                  }
                  this.user.isDefaultDesignatedPerson = true
                  utils.defaultPost('Document/AddEditDesignatedPerson', this.user,
                      (res) => {
                          if (res.data > 0) {
  
                              window.showAlert('res_Msgs_DesignatedAddSuccess', 'success');
                              this.AddExternalUser = false  
                          }
                      },
                      this.handleError, true);		},
          validateEmail(email) {
                  // Check if email contains only spaces
                  if (email.trim() === "")
                      return false;
  
                  // Check if email contains '@' character
                  if (!email.includes('@'))
                      return false;
  
                  // Check if email contains '@@'
                  if (email.includes('@@'))
                      return false;
  
                  // Check if email contains spaces
                  if (/\s/.test(email))
                      return false;
  
                  // Split email into local and domain parts
                  const [localPart, domainPart] = email.split('@');
  
                  // Check if local part is empty or starts/ends with a dot
                  if (!localPart || localPart.startsWith('.') || localPart.endsWith('.'))
                      return false;
  
                  // Check if domain part is empty or starts/ends with a dot
                  if (!domainPart || domainPart.startsWith('.') || domainPart.endsWith('.'))
                      return false;
  
                  // Check if domain part contains a dot (to ensure a top-level domain is present)
                  if (!domainPart.includes('.'))
                      return false;
  
                  // Regular expression to check for a valid domain
                  const domainRegex = /^(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.)*(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9]))\.([a-zA-Z]{2,})$/;
  
                  // Regular expression to check for a valid IP address
                  const ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/;
  
                  // Check if domain part is an invalid IP address
                  if (domainRegex.test(domainPart) || ipRegex.test(domainPart))
                      return true;
                  else
                      return false;
  
                  return true;
              },
    openDeleteDialog(item) {

			window.showInformation(this.$t('res_Label_Alert'), this.$t("res_Msgs_DeletConfirmation"),
				() => {
					axios.get(constants.baseApiUrl + "Document/DeleteDesignatedPerson?userId=" + item.userId+"&&structureUserId="+item.id)
						.then((res) => this.getDesignatedPerson())
						.catch((err) => console.log(err));
				},
				() => { })
		},
      }
  }
  </script>
  